import { Grid } from '@mui/material';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { SubjectDataVM } from 'shell/view-models/search-anpr';
import { DateTime } from 'luxon';

interface ItalianForeignStateProps {
  isForeign?: boolean;
  onChange: (key: keyof SubjectDataVM, value: SubjectDataVM[keyof SubjectDataVM]) => void;
  provinceOfBirth?: string;
  municipalityOfBirth?: MunicipalityAnprVM | null;
  birthday?: DateTime | null;
}

const ItalianStateComponent = ({
  onChange,
  // provinceOfBirth,
  municipalityOfBirth,
  birthday,
}: ItalianForeignStateProps): React.ReactElement => {
  // const params: MunicipalityParams = useMemo(() => {
  //   return {
  //     province: provinceOfBirth || '',
  //   };
  // }, [provinceOfBirth]);

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item xs={12} md={5}>
        <MunicipalityList
          value={municipalityOfBirth || null}
          onChange={(municipality) => onChange('municipalityOfBirth', municipality)}
          // disabled={!provinceOfBirth}
          label="Comune di nascita"
          id="municipalityOfBirth"
          // params={params}
          fromDate={birthday}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Provincia"
          label="Provincia"
          id="provinceOfBirth"
          name="provinceOfBirth"
          fullWidth
          type="text"
          disabled
          variant="outlined"
          value={municipalityOfBirth?.province || ''}
          onChange={(event) => onChange('provinceOfBirth', event.target.value)}
        />
      </Grid>
    </Grid>
  );
};

ItalianStateComponent.displayName = 'Filters Person section Italian State component';

const ItalianState = memo(ItalianStateComponent);

export default ItalianState as typeof ItalianStateComponent;
